import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'editFacility';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';

export var EditFacility = React.createClass({
    getInitialState() {
        return {

            Okmessage: null,
            isImageUploaded: false, // To know whether image was uploaded to server successfully
            mobileCssClass: "inputText",
            deskNumberCssClass: "inputText",
            zipCssClass: "inputText",

            fileUploaded: null, // To show uploaded file name in UI
            isFormSubmited: null,
            isSubmitEnabled: null,
            isEditMode: null,

        }
    },

    componentWillMount() {
        var facilityid = this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(facilityid));

    },

    componentWillReceiveProps(nextProps) {
        // Facility image upload response
        if (nextProps.FacilitiesDetails.FacilityImageUpload && nextProps.FacilitiesDetails.FacilityImageUpload.status === 200) {
            nextProps.FacilitiesDetails.FacilityImageUpload.status = null;
            this.setState({ isImageUploaded: true, isEditMode: true, isSubmitEnabled: true })
        }
        else {
            this.setState({ isImageUploaded: false });
        }

        // update facility response
        if (this.state.isSubmitEnabled && this.state.isFormSubmited) {
            this.setState({ isSubmitEnabled: null, isFormSubmited: null });

            if (nextProps.FacilitiesDetails.FaciliteUpdateDeatils && nextProps.FacilitiesDetails.FaciliteUpdateDeatils.status === 200) {
                this.setState({ isEditMode: null });
                // this.setState({ Okmessage: "Clinic details updated successfully." });
                this.setState({ Okmessage: nextProps.FacilitiesDetails.FaciliteUpdateDeatils.message });

                this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(this.props.UserDetails.selectdUserFacilityID));
                this.props.Dispatch(FacilitiesActions.facilityUpdate(null));
            }
            else {
                this.setState({ Okmessage: nextProps.FacilitiesDetails.FaciliteUpdateDeatils.message });
            }
        }

    },

    email_validate(event) {
        validate.email(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phone_validate(event) {
        validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    alternate_phone_validate(event) {
        if (event.target.value.trim().length) {
            validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
        }
    },

    url_validate(event) {
        let url = event.target.value.trim();
        if (url.length > 0) {
            validate.website(url) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
        }
    },
    zipcode_validate(event) {
        validate.zipCode(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    closebox() {
        this.setState({ Okmessage: null });
    },

    remove_error(event) {
        event.target.className = 'inputText';
    },

    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },
    editfacilityDetails() {

        this.setState({ Okmessage: null, isFormSubmited: null });
        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ Okmessage: "Please update any field to save." });
            return;
        }

        // validation for ClinicName
        let isValidClinicName = validate.name(this.refs['clinicName']);
        isValidClinicName ? this.refs.clinicName.className = 'inputText' : this.refs.clinicName.className = 'inputText error';

        //validation for Email
        let isValidEmail = validate.email(this.refs['email'].value);
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

        //validation for mobile
        let isValidmobile = validate.phone(this.refs.mobile.state.value);
        isValidmobile ? this.setState({ mobileCssClass: "inputText" }) : this.setState({ mobileCssClass: "inputText error" });

        //validation for desk number
        let isAltenatePhoneAvailable = null;
        let isValidDeskNumber = null;
        if (this.refs.deskNumber.state.value.trim().length) {
            isAltenatePhoneAvailable = true;
            isValidDeskNumber = validate.phone(this.refs.deskNumber.state.value);
            isValidDeskNumber ? this.setState({ deskNumberCssClass: "inputText" }) : this.setState({ deskNumberCssClass: "inputText error" });
        }

        //validation for Url
        let isValidwebsiteUrl = null,
            Url = this.refs.url.value.trim();
        if (Url.length > 0) {
            isValidwebsiteUrl = validate.website(Url);
            isValidwebsiteUrl ? this.refs.url.className = "inputText" : this.refs.url.className = "inputText error";
        } else {
            this.refs.url.className = "inputText";
        }

        // validation for Street
        let isValidstreet = validate.name(this.refs['street']);
        isValidstreet ? this.refs.street.className = 'inputText' : this.refs.street.className = 'inputText error';

        // validation for City
        let isValidCity = validate.name(this.refs['city']);
        isValidCity ? this.refs.city.className = 'inputText' : this.refs.city.className = 'inputText error';

        // validation for State
        let isValidState = validate.name(this.refs['state']);
        isValidState ? this.refs.state.className = 'inputText' : this.refs.state.className = 'inputText error';

        // validation for Country
        let isValidCountry = validate.name(this.refs['country']);
        isValidCountry ? this.refs.country.className = 'inputText' : this.refs.country.className = 'inputText error';

        //validation for zip code
        let isValidZipCode = validate.zipCode(this.refs.zipCode.state.value);
        isValidZipCode ? this.setState({ zipCssClass: "inputText" }) : this.setState({ zipCssClass: "inputText error" });

        if (this.refs.clinicName.value.trim().length === 0 || this.refs.street.value.trim().length === 0 || this.refs.city.value.trim().length === 0 || this.refs.state.value.trim().length === 0 || this.refs.country.value.trim().length === 0 || this.refs.zipCode.state.value.length === 0 || this.refs.mobile.state.value.length === 0) {

            this.setState({ Okmessage: "Please enter necessary fields to proceed." });
            return false;
        }

        if (isValidClinicName && isValidEmail && isValidmobile && (isAltenatePhoneAvailable ? isValidDeskNumber : true) && (Url.length > 0 ? isValidwebsiteUrl : true) && isValidstreet && isValidCity && isValidState && isValidCountry && isValidZipCode) {
            var data = {
                "address": {
                    "street": this.refs.street.value.trim(),
                    "city": this.refs.city.value.trim(),
                    "state": this.refs.state.value.trim(),
                    "country": this.refs.country.value.trim(),
                    "zipCode": this.refs.zipCode.state.value.trim(),
                },

                "email": this.refs.email.value.trim(),
                "mobile": this.refs.mobile.state.value.replace(/ /g, ""),
                "url": this.refs.url.value.trim(),
                "name": this.refs.clinicName.value.trim(),
                "id": this.props.AdminFacilityDetails.data.id,
                "updatedBy": {
                    "id": this.props.LogingDetails.data.id
                }
            };
            if (isValidDeskNumber) {
                data.deskNumber = this.refs.deskNumber.state.value.replace(/ /g, "");
            }

            if (this.props.FacilitiesDetails.FacilityImageUpload) {
                data.imageUrl = this.props.FacilitiesDetails.FacilityImageUpload.data;
            }

            this.setState({ isFormSubmited: true });
            this.props.Dispatch(FacilitiesActions.updateFacility(data));

        }
        else {
            this.setState({ Okmessage: "Please enter necessary fields to proceed." });
        }


    },

    uploadFacilityImage(e) {
        // if User doesn't select(if he click on cancle) any image
        //To check if user upload any file
        if (e.target.files.length === 0) {
            return;
        }

        var fuData = e.target.files[0];
        var FileUploadPath = fuData.name;
        var size = fuData.size;

        //To check the uploaded file is an image
        var Extension = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
        if (Extension == "png" || Extension == "jpeg" || Extension == "jpg") {

            if (size < 2097152) {
                var files = e.target.files || e.dataTransfer.files;
                var imageData = new FormData();
                let file = files[0];
                this.setState({ fileUploaded: file.name });
                imageData.append("file", e.target.files[0]);
                this.props.Dispatch(FacilitiesActions.uploadFacilityImage(imageData,'CLINIC', this.props.UserDetails.selectdUserFacilityID));
            }
            else {
                e.target.value = "";
                this.setState({ Okmessage: "Please select an image that is less than 2MB.", });
            }

        }
        else {
            e.target.value = "";
            this.setState({
                Okmessage: "Only photos with extension .png, .jpg, .jpeg are allowed.",
            })
        }
    },

    render() {


        return (
            <div >
                <Header screenIdentifier={screenIdentifier} />

                {this.props.AdminFacilityDetails && this.props.AdminFacilityDetails.data &&

                    <div className="row">
                        <div className="col-xs-12 no-padding recovery">
                            <div className="row">
                                <div className="col-xs-6 padding-right-20">
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="clinicName" required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.name : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                        <span className="floating-label">Clinic Name</span>
                                    </div>
                                    <div className="input-group readonly">
                                        <input type="text" className="inputText" tabIndex="-1" ref="email" maxLength="64" onFocus={this.remove_error} onBlur={this.email_validate} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.email : ""} />
                                        <span className="floating-label">Email</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.phone_validate} ref="mobile" defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.mobile : ""} required mask="999 999 9999" maskChar={null}></InputMask>
                                        <span className="floating-label">Primary Phone</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.deskNumberCssClass} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.alternate_phone_validate} ref="deskNumber" defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.deskNumber : ""} required mask="999 999 9999" maskChar={null}></InputMask>
                                        <span className="floating-label">Alternate Phone </span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="url" maxLength="64" onBlur={this.url_validate} onChange={this.enableSubmit} onFocus={this.remove_error} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.url : ""} />
                                        <span className="floating-label">Website</span>
                                    </div>
                                    <div className="input-group">
                                        <div className="facility-upload">
                                            <p><label className="uploadBtn gray-button" htmlFor="upload">Upload Clinic image</label>
                                                <input id="upload" type="file" ref="imageUrl" onChange={this.uploadFacilityImage} onFocus={this.remove_error} defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.imageUrl : ""} required />
                                                <span>{this.state.fileUploaded ? this.state.fileUploaded : this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.imageUrl : ""} </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xs-6 no-padding ">
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="street" maxLength="64" onFocus={this.remove_error} onChange={this.enableSubmit} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.address.street : ""} />
                                        <span className="floating-label">Street</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="city" maxLength="64" onFocus={this.remove_error} onChange={this.enableSubmit} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.address.city : ""} />
                                        <span className="floating-label">City</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="state" maxLength="64" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.address.state : ""} />
                                        <span className="floating-label">State</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="country" maxLength="64" onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} required defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.address.country : ""} />
                                        <span className="floating-label">Country</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.zipCssClass} defaultValue={this.props.AdminFacilityDetails ? this.props.AdminFacilityDetails.data.address.zipCode : ""} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.zipcode_validate} ref="zipCode" maxLength="5" mask="99999" maskChar={null} required />
                                        <span className="floating-label">Zip</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 no-padding recovery-buttons">
                                <button className="gray-button" onClick={this.editfacilityDetails}>{this.state.isEditMode ? "SAVE" : "EDIT"}</button>
                            </div>
                        </div>
                    </div>
                }

                {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}
            </div >
        );
    }
});


let mapStateToProps = (state) => {
    return {
        FacilitiesDetails: state.Facilites,
        UserDetails:state.User,
        LogingDetails: state.User.loginData,
        AdminFacilityDetails: state.Facilites.FaciliteDetailsByID,
        ProfileUpdate: state.User.ProfileUpdate,
        SettingsUpdate: state.Setting

    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(EditFacility));



/** WEBPACK FOOTER **
 ** ./src/components/admin/clinicSettings/editfacility.js
 **/